import {clone} from 'ramda'
import all from './all'

export default {
  ...clone(all),
  id: 'test',
}
